import React from 'react';
import PropTypes from 'prop-types';

import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ManagedInput from 'components/form/managed_input';

export default function Header({ deals, selectedDeal, onDealChange }) {
  if (!selectedDeal) {
    return null;
  }

  return (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <div className="selected-deal">
        <ManagedInput
          aria-label="dealSidebarSelect"
          name="selectedDeal"
          type="select"
          value={selectedDeal.id}
          onValueChange={id => onDealChange(deals.find(deal => deal.id === parseInt(id)))}
        >
          {deals.map(deal => (
            <option key={deal.id} value={deal.id}>
              {deal.displayName}
            </option>
          ))}
        </ManagedInput>
      </div>
      {!selectedDeal?.parent && selectedDeal?.path && (
        <a aria-label="dealSidebarLink" className="d-flex align-items-center" href={selectedDeal.path}>
          View Deal <FontAwesomeIcon icon={faAngleRight}/>
        </a>
      )}
    </div>
  );
}

Header.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object),
  selectedDeal: PropTypes.object,
  onDealChange: PropTypes.func.isRequired,
};
